import request from '@/utils/request';

/**
 * 获取当前登录用户
 */
export function currentUser() {
  return request.get<API.User>('/api/user/current');
}

/**
 * 获取当前用户权限
 */
export function userPermission() {
  return request.get<string[]>('/api/user/permission');
}

/**
 * 修改用户密码
 * @param data
 */
export function modifyPassword(data: {
  oldPassword: string;
  newPassword: string;
}) {
  return request.post('/api/user/modify_password', data);
}

/**
 * 获取用户详情
 * @param id
 */
export function getUser(id: string) {
  return request.get<API.User>(`/api/user/${id}`);
}

/**
 * 获取用户分页列表
 * @param params
 */
export function getUserPage(params: API.PageReq) {
  return request.get<API.Page<API.User>>('/api/user/page', {
    params,
  });
}

/**
 * 获取所有用户列表
 * @param params
 */
export function getAllUser(params: Record<string, any> = {}) {
  return request.get<API.User[]>('/api/user/all', {
    params,
  });
}

/**
 * 保存用户
 * @param data
 */
export function saveUser(data: API.User) {
  return request.post('/api/user', data);
}

/**
 * 删除用户
 * @param id
 */
export function deleteUser(id: string) {
  return request.delete(`/api/user/${id}`);
}

/**
 * 重置用户密码
 * @param id
 */
export function resetPassword(id: string) {
  return request.post<string>(`/api/user/reset_password/${id}`);
}
